import { Star } from 'lucide-react';
import { useTravellerFeedback } from '../../../../../../context/travellerFeedback/TravellerFeedbackContext';
import { formatFeedbackDate, formatBookingId } from '../../../../utils/feedbackHelpers';

const FeedbackCard = ({ feedback }) => {
  const { setSelectedFeedback } = useTravellerFeedback();

  const bookingIdFormatted = formatBookingId(feedback.booking_id);

  return (
    <div className="bg-white rounded-2xl border border-slate-100 border-l-4 border-l-[#067978]/70 p-5 shadow-xs hover:shadow-md transition-all flex flex-col justify-between">
      <div>
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-slate-50 border border-slate-100 text-slate-600 font-bold text-xs flex items-center justify-center flex-shrink-0">
              {(feedback.user_name || 'A').charAt(0).toUpperCase()}
            </div>
            <div>
              <h3 className="font-bold text-slate-800 text-sm">
                {feedback.user_name || 'Anonymous User'}
              </h3>
              <div className="flex items-center gap-1 mt-0.5">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star
                    key={star}
                    size={12}
                    className={star <= feedback.rating ? "fill-amber-400 text-amber-400" : "text-slate-200"}
                  />
                ))}
                <span className="text-[10px] text-slate-400 ml-1.5 font-medium">({feedback.rating}/5)</span>
              </div>
            </div>
          </div>
          <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider bg-slate-50/80 border border-slate-100 px-2 py-0.5 rounded-md">
            {formatFeedbackDate(feedback.createdAt)}
          </span>
        </div>

        <p className="text-slate-600 text-sm leading-relaxed italic mb-4">
          "{feedback.feedback_text}"
        </p>
      </div>

      <div className="flex items-center justify-between pt-3 border-t border-slate-100 mt-2">
        <div className="text-[10px] text-slate-400 font-mono font-bold lowercase">
          {bookingIdFormatted && `booking id: ${bookingIdFormatted}`}
        </div>
        <button
          className="px-3.5 py-1.5 bg-slate-50 hover:bg-teal-50 border border-slate-100 text-xs font-bold text-[#067978] rounded-xl transition-all cursor-pointer"
          onClick={() => setSelectedFeedback(feedback)}
        >
          View Details
        </button>
      </div>
    </div>
  );
};

export default FeedbackCard;
